import styled from "styled-components";
import {
  Input as InputAnt,
  Form as FormAnt,
  Col as ColAnt,
  Row as RowAnt,
} from "antd";
import {
  EyeOutlined,
  EyeInvisibleOutlined,
  InfoCircleOutlined,
} from "@ant-design/icons";

export const Col = styled(ColAnt)``;

export const Row = styled(RowAnt)`
  width: 100%;
  align-items: center;
  justify-content: center;
  grid-gap: 5px;
`;

export const Box = styled.div`
  display: flex;
  justify-content: center;
  grid-gap: 5px;

  @media (max-width: 1440px) {
    width: 100%;
  }

  @media (max-width: 1024px) {
    width: 100%;
  }

  @media (max-width: 768px) {
    flex-direction: column;
    align-items: flex-start;
  }
`;

export const FormItem = styled(FormAnt.Item)`
  .ant-form-item-label
    > label.ant-form-item-required:not(
      .ant-form-item-required-mark-optional
    )::after {
    display: inline-block;
    color: var(--orange-150);
    content: "*";
  }
  .ant-form-item-label
    > label.ant-form-item-required:not(
      .ant-form-item-required-mark-optional
    )::before {
    content: "";
  }
`;

export const Input = styled(InputAnt)`
  margin-top: 0.3rem;
  border: var(--gray-100) 1px solid !important;
  ::placeholder {
    height: 3.25rem;
    color: var(--gray-500);
  }

  @media (max-width: 768px) {
    font-size: 14px;
  }
`;

export const InfoIcon = styled(InfoCircleOutlined)`
  color: var(--orange-100) !important;
`;

export const PasswordValidationList = styled.ul`
  list-style: none;
  padding: 0;
  margin: 5px 0 0 0;
  width: 100%;
`;

export const ValidationItem = styled.li<{ isValid: boolean }>`
  display: flex;
  align-items: center;
  margin-bottom: 3px;
  font-size: 12px;
  color: ${(props) => (props.isValid ? "#52c41a" : "#ff4d4f")};

  &:before {
    content: ${(props) => (props.isValid ? '"✓"' : '"✗"')};
    margin-right: 5px;
    font-weight: bold;
  }

  @media (max-width: 1024px) {
    font-size: 11px;
  }

  @media (max-width: 768px) {
    font-size: 10px;
  }
`;

export const EyeIcon = styled(EyeOutlined)`
  cursor: pointer;
`;

export const EyeIconInvisible = styled(EyeInvisibleOutlined)`
  cursor: pointer;
`;
